/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:54:35                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-05 14:55:14                               *
 *****************************************************************************/

/* SUMMARY
  * Components
  * ProspectListItem: display prospect item in table
*/

/* Components */
import DateDisplay from "../date/DateDisplay";
import TechnicianDisplay from "../technician/TechnicianDisplay";
import CustomerDisplay from "../customer/CustomerDisplay";
import ContactDisplay from "../contact/ContactDisplay";
import ProspectAdminActions from "../../../views/super-admin/views/prospects/ProspectAdminActions";
import { Typography } from "@material-tailwind/react";
import { format } from "date-fns";
import { OverflowTooltip } from "../../table/TableCellTooltip";
/***/

/**
* ProspectListItem: display prospect item in table
* @param prospect - prospect item to display
* @param onClick - function to call when item is clicked
* @param isLast - is last item in list 
*/
export default function ProspectListItem({
  prospect,
  onClick,
  onChange,
  isLast = false,
  isAdminComponent,
  customer
}: {
  prospect: EasyTech.Prospect,
  onClick?: () => void,
  onChange?: () => void,
  isLast?: boolean,
  isAdminComponent?: boolean,
  customer?: EasyTech.Customer
}) {
  const href = `/visits/${prospect.id}`;
  const visitDate = format(new Date(prospect.date), "dd/MM/yyyy");
  const technicianLabel = prospect.technician
    ? `${prospect.technician.firstName} ${prospect.technician.lastName}`.trim()
    : "-";
  const contactLabel = prospect.contact
    ? `${prospect.contact.firstName} ${prospect.contact.lastName}`.trim()
    : "-";

  // Gestion des raccourcis clavier et menu contextuel
  const handleRowClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
    // CTRL/CMD + click pour ouvrir dans un nouvel onglet
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
      window.open(href, "_blank");
      return;
    }
    
    // Clic normal
    onClick?.();
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLTableRowElement>) => {
    // Bouton du milieu (scroll) pour ouvrir dans un nouvel onglet
    if (e.button === 1) {
      e.preventDefault();
      window.open(href, "_blank");
    }
  };

  return (
    <tr
      className={`page-list-item${isLast ? " last" : ""}`}
      tabIndex={0}
      style={{ cursor: "pointer" }}
      onClick={handleRowClick}
      onMouseDown={handleMouseDown}
      data-href={href}
    >
      <td>
        <a href={href} className="block w-full h-full" onClick={(e) => e.preventDefault()}>
          <OverflowTooltip content={prospect.ref} className="et-cell-truncate">
            <Typography variant={"small"}>
              {prospect.ref}
            </Typography>
          </OverflowTooltip>
        </a>
      </td>

      <td>
        <a href={href} className="block w-full h-full" onClick={(e) => e.preventDefault()}>
          <OverflowTooltip content={visitDate} className="et-cell-truncate">
            <DateDisplay date={new Date(prospect.date)} size={"small"} noToolTip />
          </OverflowTooltip>
        </a>
      </td>

      <td>
        <a href={href} className="block w-full h-full" onClick={(e) => e.preventDefault()}>
          <OverflowTooltip content={prospect.hour || "-"} className="et-cell-truncate">
            <Typography variant="small">
              {prospect.hour || "-"}
            </Typography>
          </OverflowTooltip>
        </a>
      </td>

      <td>
        <a href={href} className="block w-full h-full" onClick={(e) => e.preventDefault()}>
          <OverflowTooltip content={technicianLabel} className="et-cell-truncate">
            <TechnicianDisplay technician={prospect.technician} size={"small"} noToolTip />
          </OverflowTooltip>
        </a>
      </td>

      {customer === undefined &&
        <td>
          <a href={href} className="block w-full h-full" onClick={(e) => e.preventDefault()}>
            <div className="et-cell-wrap">
              <CustomerDisplay customer={prospect.customer} size={"small"} noToolTip />
            </div>
          </a>
        </td>
      }

      <td>
        <a href={href} className="block w-full h-full" onClick={(e) => e.preventDefault()}>
          <OverflowTooltip content={contactLabel} className="et-cell-truncate">
            <ContactDisplay contact={prospect.contact} size={"small"} noToolTip />
          </OverflowTooltip>
        </a>
      </td>

      {isAdminComponent === true &&
        <td className="z-10" data-no-link>
          {/* Stop propagation pour exclure la colonne action */}
          <div onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
            <ProspectAdminActions
              prospect={prospect}
              onChange={() => { if (onChange) onChange(); }}
            />
          </div>
        </td>
      }
    </tr>
  );
}
